import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { Location } from '@angular/common'
import { fuseAnimations } from '../../../../../core/animations'
import { ActivatedRoute } from '@angular/router'
import { TellowConstants } from '../../../enums/TellowConstants'
import { DocumentsService } from '../../../../services/documents.service'

@Component({
  selector: 'app-document-list-sidenav',
  templateUrl: './document-list-sidenav.component.html',
  styleUrls: ['./document-list-sidenav.component.scss'],
  animations: fuseAnimations,
})
export class DocumentListSidenavComponent implements OnInit {
  @Input() view: string

  @Output()
  changeView = new EventEmitter<any>()

  documentStates = TellowConstants.getDocumentStates()
  documentReasons = TellowConstants.getReasons()
  selectedStatus: string
  selectedReason: string
  filter: string

  constructor(private route: ActivatedRoute, private _location: Location, private _documentService: DocumentsService) {
    this.view = this.route.snapshot.params['view']
  }

  ngOnInit() {
    // this.baseUrl = 'administrations/'+ this.administration.id;
  }

  changeFilter(key, value) {
    this._documentService.filter(key, value)
    this.filter = undefined
  }

  filterBeforeStartDate($event) {
    this.filter = 'BEFORE_START_DATE'
    this.selectedStatus = 'IN_PROGRESS'
    this.selectedReason = 'REJECTED_BEFORE_START_DATE'
    this._documentService.mergeFilters({
      status: 'IN_PROGRESS',
      reason: 'REJECTED_BEFORE_START_DATE',
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/documents/document-list/document-list-sidenav/document-list-sidenav.component.ts